const baseURL = process.env.REACT_APP_BASE_URL;
const imgBaseURL = process.env.REACT_APP_IMG_BASE_URL;
// process.env.NODE_ENV === 'development'
//   ? // ? 'http://localhost:8000/api'
//     process.env.REACT_APP_IMG_BASE_URL
//   : process.env.REACT_APP_IMG_BASE_URL;

export { baseURL, imgBaseURL };
